<template>
  <div class="reset">
    <div class="container">
      <div class="reset__wrapper">
        <div class="reset__top">
          <h1>{{ t('auth.reset.title') }}</h1>
        </div>
        <reset-password-form />
      </div>
    </div>
  </div>
</template>

<script setup>
import {useI18n} from "vue-i18n";
import ResetPasswordForm from "@/components/forms/reset-password-form.vue";

const {t} = useI18n()
</script>

<style lang="scss" scoped>
.reset {
  padding-top: 90px;
  position: relative;

  &__bg {
    &-left {
      position: absolute;
      top: 0;
      left: 0;
    }

    &-right {
      position: absolute;
      top: 0;
      right: 0;
    }
  }

  &__wrapper {
    padding-top: 55px;
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    gap: 50px;
  }

  &__top {
    border-bottom: 1px solid #1E1E1E;
    display: grid;
    place-items: center;

    & h1 {
      width: 400px;
      padding-bottom: 10px;
      border-bottom: 3px solid #3b3b3b;

      text-align: center;
      color: #3b3b3b;
      font-size: 24px;
      font-weight: 700;
      line-height: 30px;
    }
  }
}

@media (max-width: 600px) {
  .reset {
    &__top {
      & h1 {
        width: 100%;
      }
    }
  }
}
</style>